import { notificationsTypes } from "@/types";

export const state: notificationsTypes = {
  isError: false,
  isSuccess: false,
  successMessage: "",
  errorMessage: ""
};
